import {FunctionUtils} from "@/lib/utils/functionUtils";

export namespace ObjectUtils {
  export function bindOwnProperties<T extends object>(target: T): void {
    const prototype = Object.getPrototypeOf(target);
    const ownProperties = Object.getOwnPropertyNames(prototype) as Array<keyof T>;

    ownProperties.forEach((propertyName) => {
      if (propertyName !== "constructor") {
        const descriptor = Object.getOwnPropertyDescriptor(prototype, propertyName);

        if (descriptor && FunctionUtils.isFunction(descriptor.value)) {
          target[propertyName] = descriptor.value.bind(target);
        }
      }
    });
  }
}
